import "./styles.scss";

import classnames from "classnames";
import { createPortal } from "react-dom";
import { NavLink } from "react-router-dom";
import React, { forwardRef, useLayoutEffect, useState } from "react";

const mainClass = "dashboard-menu__float-card";

const FloatCard = forwardRef(({ setSidebarOpen, data, active }, ref) => {
  const [position, setPosition] = useState(null);

  const status_class_render = (status) => {
    switch (status) {
      case 1:
        return "good";
      case 2:
      case 4:
        return "wrong";
      case 3:
        return "verification";
      default:
        return {
          text: "-",
          class: null,
        };
    }
  };

  useLayoutEffect(() => {
    if (!!!active || !ref.current?.getBoundingClientRect()) return;

    setPosition({
      x: ref.current.getBoundingClientRect()?.right + window.scrollX,
      y: ref.current.getBoundingClientRect()?.top + window.scrollY,
    });

    window.addEventListener("scroll", () => {
      if (!ref.current?.getBoundingClientRect()) return;

      setPosition({
        x: ref.current.getBoundingClientRect()?.right + window.scrollX,
        y: ref.current.getBoundingClientRect()?.top + window.scrollY,
      });
    });
    // eslint-disable-next-line
  }, [active]);

  return createPortal(
    <div
      className={classnames(mainClass, {
        [`${mainClass}--active`]: !!active,
      })}
      style={{
        top: position?.y,
        left: position?.x,
      }}
    >
      <div className={`${mainClass}__wrapper`}>
        {data?.map(
          ({ icon, label, href, status, disabled, active, onClick }, index) => {
            const status_class = status_class_render(status);

            return status ? (
              <button
                key={index}
                onClick={() => {
                  setSidebarOpen(false);

                  if (typeof onClick === "function") onClick();
                }}
                className={classnames(`${mainClass}__item`, {
                  [`${mainClass}__item--active`]: !!active,
                  [status_class]: !!status_class,
                  disabled: !!disabled,
                })}
              >
                <span>{label}</span>
                <div className={`${mainClass}__item__radio`} />
              </button>
            ) : (
              <div
                key={index}
                className={classnames(
                  `dashboard-layout-sidebar__menu__list`,
                  `${mainClass}__menu__list--extra-padding`,
                )}
              >
                <NavLink
                  to={href}
                  onClick={() => {
                    setSidebarOpen(false);

                    if (typeof onClick === "function") onClick();
                  }}
                  style={{ paddingRight: 24 }}
                  className={({ isActive }) =>
                    isActive
                      ? `dashboard-layout-sidebar__menu__list--active`
                      : ""
                  }
                >
                  <div className={`dashboard-layout-sidebar__menu__list__icon`}>
                    {icon}
                  </div>
                  <span>{label}</span>
                </NavLink>
              </div>
            );
          },
        )}
      </div>
    </div>,
    document.body,
  );
});

export default FloatCard;
